export interface TicketMessageAttachmentGroups {
  images: string[];
  documents: string[];
}

const TICKET_IMAGE_PATTERN = /\.(png|jpe?g|gif)(\?.*)?$/i;

export function isTicketImageAttachment(path: string): boolean {
  return TICKET_IMAGE_PATTERN.test(path);
}

export function groupTicketMessageAttachments(
  attachments: readonly string[] | undefined,
): TicketMessageAttachmentGroups {
  const groups: TicketMessageAttachmentGroups = {
    images: [],
    documents: [],
  };

  for (const attachment of attachments ?? []) {
    if (isTicketImageAttachment(attachment)) groups.images.push(attachment);
    else groups.documents.push(attachment);
  }

  return groups;
}
